import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import * as authApi from "../api/auth";

export default function ValidarEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [estado, setEstado] = useState("cargando"); // cargando | exito | error
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    if (!token) {
      setEstado("error");
      setMensaje("Enlace de validación inválido: falta el token.");
      return;
    }
    authApi
      .validarEmail(token)
      .then((r) => {
        setEstado("exito");
        setMensaje(r.mensaje || "Correo validado correctamente.");
      })
      .catch((err) => {
        setEstado("error");
        setMensaje(err.response?.data?.mensaje || "No se pudo validar el correo.");
      });
  }, [token]);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center px-3"
         style={{ background: "linear-gradient(160deg, #0C8599 0%, #075463 100%)" }}>
      <div className="fs-card shadow-lg text-center" style={{ maxWidth: 420, width: "100%" }}>
        {estado === "cargando" && (
          <>
            <Spinner animation="border" className="mb-3" style={{ color: "var(--fs-primary)" }} />
            <p className="mb-0">Validando tu correo...</p>
          </>
        )}
        {estado === "exito" && (
          <>
            <i className="bi bi-check-circle-fill text-fs-ingreso" style={{ fontSize: "2.5rem" }}></i>
            <h5 className="mt-3">¡Correo validado!</h5>
            <p className="text-muted">{mensaje}</p>
            <Link to="/login" className="btn btn-primary w-100 mt-2">Ir a iniciar sesión</Link>
          </>
        )}
        {estado === "error" && (
          <>
            <i className="bi bi-x-circle-fill text-fs-gasto" style={{ fontSize: "2.5rem" }}></i>
            <h5 className="mt-3">No pudimos validar tu correo</h5>
            <p className="text-muted">{mensaje}</p>
            <Link to="/login" className="btn btn-outline-primary w-100 mt-2">Volver al inicio</Link>
          </>
        )}
      </div>
    </div>
  );
}
